import { Input } from "@/components/ui/input";

interface HoneypotFieldProps {
  value: string;
  onChange: (value: string) => void;
}

/**
 * Honeypot field for bot detection
 * This field is hidden from users but bots will fill it
 * If the field has any value, the form submission should be rejected
 */
export function HoneypotField({ value, onChange }: HoneypotFieldProps) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        left: '-9999px',
        top: '-9999px',
        height: 0,
        width: 0,
        overflow: 'hidden',
        opacity: 0,
        pointerEvents: 'none',
      }}
    >
      <label htmlFor="website_url">Website URL</label>
      <Input
        type="text"
        id="website_url"
        name="website_url"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

/**
 * Validate honeypot - returns true if honeypot is filled (likely bot)
 */
export function isHoneypotFilled(value: string): boolean {
  return value.length > 0;
}
